/**
 * PocketFiler - Arabic (ar) Translation File
 * Complete translation - all keys from en.js
 * Right-to-left (RTL) language
 */

const ar = {
  "nav.login": "تسجيل الدخول",
  "nav.signup": "ابدأ الآن",
  "nav.logout": "تسجيل الخروج",
  "nav.dashboard": "لوحة التحكم",
  "nav.virtualOffices": "المكاتب الافتراضية",
  "nav.clients": "العملاء",
  "nav.deals": "الصفقات",
  "nav.documents": "المستندات",
  "nav.messages": "الرسائل",
  "nav.settings": "الإعدادات",
  "nav.invoices": "الفواتير",
  "nav.templates": "القوالب",
  "nav.tasks": "المهام",
  "nav.meetings": "الاجتماعات",
  "nav.analytics": "التحليلات",
  "landing.badge": "منصة صفقات مدعومة بالذكاء الاصطناعي",
  "landing.hero.title": "أبرم صفقات مهمة بأي لغة",
  "landing.hero.titleHighlight": "بالذكاء الاصطناعي",
  "landing.hero.subtitle": "يساعد PocketFiler الشركات والأفراد على إجراء معاملات موثوقة كثيفة المستندات - من التجارة العالمية إلى مبيعات السيارات المحلية ووثائق التأمين - مع الترجمة بالذكاء الاصطناعي وسير عمل المستندات وغرف الصفقات لكل معاملة.",
  "landing.hero.cta.start": "ابدأ مجاناً",
  "landing.hero.cta.demo": "شاهد كيف يعمل",
  "landing.useCases.title": "مصمم للتجارة العالمية والخدمات المحلية والصفقات الشخصية الكبيرة",
  "landing.useCases.subtitle": "سواء كنت تستورد بضائع من الخارج أو تبيع سيارتك في المدينة، يوفر لك PocketFiler الأدوات للإغلاق بثقة.",
  "landing.useCases.globalTrade.title": "التجارة العالمية والتصنيع",
  "landing.useCases.globalTrade.desc": "ابحث عن موردين خارجيين واعمل معهم، واجمع مستندات الامتثال، وتفاوض في غرف الصفقات مع ترجمة فورية.",
  "landing.useCases.insurance.title": "التأمين والقروض والخدمات المهنية",
  "landing.useCases.insurance.desc": "ادعُ العملاء لتحميل الهويات والكشوف والنماذج بلغتهم، ثم تتبع كل مستند ورسالة في المكاتب الافتراضية.",
  "landing.useCases.realEstate.title": "العقارات ومعاملات الممتلكات",
  "landing.useCases.realEstate.desc": "وجّه المشترين والمستأجرين خلال الطلبات والإفصاحات والعقود بلغات متعددة، كل ذلك في غرفة صفقات واحدة لكل معاملة.",
  "landing.useCases.vehicle.title": "مبيعات المركبات والأصول الخاصة",
  "landing.useCases.vehicle.desc": "استخدم غرف الصفقات والعقود المُنشأة بالذكاء الاصطناعي للتعامل مع وثائق البيع للسيارات والمعدات والعناصر عالية القيمة الأخرى.",
  "landing.audience.title": "مصمم للأفراد والفرق",
  "landing.audience.individuals.title": "للأفراد",
  "landing.audience.individuals.bullet1": "أبرم صفقات مهمة لمرة واحدة مثل شراء السيارات أو المعدات أو العناصر عالية القيمة مع سجلات واضحة.",
  "landing.audience.individuals.bullet2": "استخدم روابط آمنة بسيطة لتحميل المستندات ومراجعة العقود من هاتفك.",
  "landing.audience.individuals.bullet3": "احتفظ بجميع الرسائل والملفات ومسودات العقود لكل صفقة في مكان واحد، حتى بعد انتهاء الصفقة.",
  "landing.audience.teams.title": "للشركات والفرق",
  "landing.audience.teams.bullet1": "أنشئ مكاتب افتراضية لكل خط خدمة (تأمين، عقارات، قروض، استيراد) مع قوائم مراجعة مخصصة.",
  "landing.audience.teams.bullet2": "ادعُ العملاء بأي لغة لتحميل المستندات وتوقيع العقود والتواصل في غرف الصفقات.",
  "landing.audience.teams.bullet3": "امنح فريقك مساحة عمل مشتركة مع جداول زمنية وملخصات الذكاء الاصطناعي وسجل كامل لكل معاملة.",
  "landing.howItWorks.title": "كيف يعمل PocketFiler لأي صفقة",
  "landing.howItWorks.subtitle": "أربع ميزات قوية تعمل معاً لمساعدتك على إبرام الصفقات بشكل أسرع وبأقل احتكاك.",
  "landing.howItWorks.concierge.title": "مساعد الذكاء الاصطناعي",
  "landing.howItWorks.concierge.desc": "يتعلم مساعدك الذكاء الاصطناعي عملك، ويُنشئ المكاتب الافتراضية المناسبة، ويُعد قوائم مراجعة المستندات لكل نوع صفقة.",
  "landing.howItWorks.translation.title": "الترجمة التلقائية",
  "landing.howItWorks.translation.desc": "تُترجم الرسائل والمحتوى الرئيسي فوراً بين الأطراف، حتى يتمكن المشترون والبائعون والعملاء من التواصل بلغتهم الخاصة.",
  "landing.howItWorks.documents.title": "المستندات الذكية",
  "landing.howItWorks.documents.desc": "يقوم العملاء بتحميل المستندات من هواتفهم؛ يستخرج الذكاء الاصطناعي الحقول الرئيسية ويتحقق من الجودة ويُشير إلى المشاكل قبل أن تبطئ الصفقة.",
  "landing.howItWorks.dealRooms.title": "غرف الصفقات والعقود",
  "landing.howItWorks.dealRooms.desc": "تحصل كل صفقة على غرفة مخصصة بجدول زمني ورسائل ومستندات ومسودات عقود مُنشأة بالذكاء الاصطناعي يمكنك مراجعتها وإتمامها.",
  "landing.cta.title": "مستعد لإبرام صفقتك القادمة؟",
  "landing.cta.subtitle": "انضم إلى الشركات والأفراد الذين يستخدمون PocketFiler للتعامل مع المعاملات المهمة بثقة.",
  "landing.cta.button": "إنشاء حساب مجاني",
  "landing.footer.tagline": "صفقات مهمة بسيطة.",
  "language.picker.title": "اختر لغتك",
  "language.picker.subtitle": "سنعرض جميع التعليمات والرسائل والعقود بهذه اللغة. يمكن للآخرين اختيار لغتهم الخاصة؛ سيتولى الذكاء الاصطناعي الترجمة.",
  "language.picker.continue": "متابعة",
  "language.picker.playSample": "تشغيل عينة",
  "language.picker.playing": "جاري التشغيل...",
  "language.picker.confirmation": "اخترت {language}. سنعرض لك كل شيء بهذه اللغة. يمكن للأطراف الأخرى اختيار لغتهم الخاصة؛ يترجم PocketFiler الرسائل والمستندات والعقود حتى يفهم الجميع.",
  "language.toast.saved": "تم حفظ اللغة! لتغييرها، انتقل إلى الإعدادات في ملفك الشخصي.",
  "language.confirm.title": "تأكيد لغتك",
  "language.confirm.subtitle": "ستُستخدم هذه اللغة لجميع واجهة المستخدم والرسائل والعقود.",
  "language.confirm.change": "تغيير اللغة",
  "language.confirm.continue": "المتابعة بـ",
  "language.confirm.chineseNote": "ملاحظة: اخترت الصينية المبسطة (简体中文). إذا كنت تفضل الصينية التقليدية، يرجى تغيير اختيارك.",
  "auth.login.title": "مرحباً بعودتك",
  "auth.login.subtitle": "سجّل الدخول إلى حساب PocketFiler",
  "auth.login.email": "البريد الإلكتروني",
  "auth.login.password": "كلمة المرور",
  "auth.login.submit": "تسجيل الدخول",
  "auth.login.noAccount": "ليس لديك حساب؟",
  "auth.login.signupLink": "سجّل الآن",
  "auth.login.error": "بريد إلكتروني أو كلمة مرور غير صالحة",
  "auth.signup.title": "أنشئ حسابك",
  "auth.signup.subtitle": "ابدأ بإبرام الصفقات بأي لغة",
  "auth.signup.name": "الاسم الكامل",
  "auth.signup.email": "البريد الإلكتروني",
  "auth.signup.password": "كلمة المرور",
  "auth.signup.confirmPassword": "تأكيد كلمة المرور",
  "auth.signup.companyName": "اسم الشركة",
  "auth.signup.companyType": "نوع الصناعة",
  "auth.signup.submit": "إنشاء الحساب",
  "auth.signup.hasAccount": "لديك حساب بالفعل؟",
  "auth.signup.loginLink": "تسجيل الدخول",
  "auth.signup.terms": "بالتسجيل، فإنك توافق على شروط الخدمة وسياسة الخصوصية الخاصة بنا.",
  "dashboard.title": "لوحة التحكم",
  "dashboard.welcome": "مرحباً بعودتك، {name}",
  "dashboard.aiSummary.title": "ملخص الذكاء الاصطناعي",
  "dashboard.aiSummary.generating": "جاري إنشاء الملخص...",
  "dashboard.stats.totalDeals": "إجمالي الصفقات",
  "dashboard.stats.activeDeals": "الصفقات النشطة",
  "dashboard.stats.totalClients": "إجمالي العملاء",
  "dashboard.stats.documentsProcessed": "المستندات المعالجة",
  "dashboard.recentDeals.title": "الصفقات الأخيرة",
  "dashboard.recentDeals.viewAll": "عرض الكل",
  "dashboard.recentDeals.empty": "لا توجد صفقات حتى الآن. أنشئ صفقتك الأولى للبدء.",
  "dashboard.recentClients.title": "العملاء الأخيرون",
  "dashboard.recentClients.viewAll": "عرض الكل",
  "dashboard.recentClients.empty": "لا يوجد عملاء حتى الآن. ادعُ عميلك الأول للبدء.",
  "dashboard.quickActions.title": "إجراءات سريعة",
  "dashboard.quickActions.createDeal": "إنشاء صفقة",
  "dashboard.quickActions.inviteClient": "دعوة عميل",
  "dashboard.quickActions.createOffice": "إنشاء مكتب افتراضي",
  "offices.title": "المكاتب الافتراضية",
  "offices.subtitle": "نظّم عملك حسب نوع الخدمة",
  "offices.create": "إنشاء مكتب افتراضي",
  "offices.empty.title": "لا توجد مكاتب افتراضية بعد",
  "offices.empty.desc": "أنشئ مكتبك الافتراضي الأول لتنظيم صفقاتك وعملائك.",
  "offices.card.clients": "{count} عملاء",
  "offices.card.deals": "{count} صفقات",
  "offices.card.checklist": "عناصر قائمة المراجعة",
  "offices.checklist": "قائمة مراجعة المستندات",
  "offices.noChecklist": "لا توجد مستندات مطلوبة",
  "offices.dialog.title": "إنشاء مكتب افتراضي",
  "offices.dialog.desc": "أعد مساحة عمل جديدة لنوع خدمة محدد",
  "offices.dialog.name": "اسم المكتب",
  "offices.dialog.namePlaceholder": "مثال: مطالبات التأمين، مبيعات العقارات",
  "offices.dialog.type": "نوع المكتب",
  "offices.dialog.description": "الوصف",
  "offices.dialog.descriptionPlaceholder": "صف ما يتعامل معه هذا المكتب...",
  "offices.dialog.checklist": "قائمة مراجعة المستندات",
  "offices.dialog.checklistHelp": "قائمة مراجعة مُنشأة بالذكاء الاصطناعي للمستندات المطلوبة",
  "offices.dialog.addItem": "إضافة عنصر",
  "offices.dialog.generateChecklist": "إنشاء بالذكاء الاصطناعي",
  "offices.dialog.creating": "جاري الإنشاء...",
  "offices.dialog.create": "إنشاء المكتب",
  "offices.form.name": "اسم المكتب",
  "offices.form.namePlaceholder": "مثال: خدمات التأمين، العقارات، إلخ.",
  "offices.form.description": "الوصف",
  "offices.form.descPlaceholder": "ما نوع الصفقات التي سيتعامل معها هذا المكتب؟",
  "offices.form.checklistPlaceholder": "إضافة مستند مطلوب...",
  "offices.ai.title": "إعداد بمساعدة الذكاء الاصطناعي",
  "offices.ai.desc": "دع مساعد الذكاء الاصطناعي لدينا يساعدك في إعداد المكتب الافتراضي المثالي من خلال السؤال عن احتياجات عملك.",
  "offices.ai.manual": "الإعداد يدوياً",
  "offices.ai.start": "بدء إعداد الذكاء الاصطناعي",
  "offices.ai.startOnboarding": "ساعدني في إعداد مكتبي الافتراضي",
  "offices.ai.suggestion": "اقتراح الذكاء الاصطناعي",
  "offices.ai.acceptSuggestion": "قبول وإنشاء المكتب",
  "offices.ai.inputPlaceholder": "اكتب ردك...",
  "clients.title": "العملاء",
  "clients.subtitle": "إدارة عملائك ودعواتك",
  "clients.invite": "دعوة عميل",
  "clients.empty.title": "لا يوجد عملاء بعد",
  "clients.empty.desc": "ادعُ عميلك الأول للبدء.",
  "clients.table.name": "الاسم",
  "clients.table.client": "العميل",
  "clients.table.contact": "جهة الاتصال",
  "clients.table.office": "المكتب",
  "clients.table.language": "اللغة",
  "clients.table.status": "الحالة",
  "clients.table.actions": "الإجراءات",
  "clients.status.invited": "مدعو",
  "clients.status.active": "نشط",
  "clients.status.completed": "مكتمل",
  "clients.dialog.title": "دعوة عميل جديد",
  "clients.dialog.name": "اسم العميل",
  "clients.dialog.email": "البريد الإلكتروني",
  "clients.dialog.phone": "رقم الهاتف",
  "clients.dialog.office": "المكتب الافتراضي",
  "clients.dialog.language": "اللغة المفضلة",
  "clients.dialog.sending": "جاري إرسال الدعوة...",
  "clients.dialog.send": "إرسال الدعوة",
  "clients.toast.invited": "تم إرسال الدعوة إلى {name}",
  "clients.toast.deleted": "تم حذف العميل",
  "clients.toast.linkCopied": "تم نسخ رابط الدعوة إلى الحافظة",
  "clients.invite.step1Title": "دعوة عميل جديد",
  "clients.invite.step2Title": "معاينة رسالة الدعوة",
  "clients.invite.step3Title": "تم إرسال الدعوة!",
  "clients.invite.step1Desc": "أدخل معلومات الاتصال بالعميل",
  "clients.invite.step2Desc": "راجع رسالة الدعوة وخصصها",
  "clients.invite.step3Desc": "شارك رابط الدعوة مع عميلك",
  "clients.invite.nameLabel": "اسم العميل",
  "clients.invite.namePlaceholder": "مثال: أحمد محمد",
  "clients.invite.contactMethod": "طريقة الاتصال",
  "clients.invite.phone": "رقم الهاتف",
  "clients.invite.customNote": "ملاحظة مخصصة",
  "clients.invite.customNotePlaceholder": "تعليمات خاصة لهذا العميل...",
  "clients.invite.previewMessage": "معاينة الرسالة",
  "clients.invite.aiGenerated": "رسالة دعوة مُنشأة بالذكاء الاصطناعي",
  "clients.invite.messagePreview": "معاينة الرسالة",
  "clients.invite.messageEditHint": "يمكنك تعديل هذه الرسالة قبل الإرسال",
  "clients.invite.documentsRequested": "المستندات المطلوبة",
  "clients.invite.regenerate": "إعادة إنشاء الرسالة",
  "clients.invite.sendInvite": "إرسال الدعوة",
  "clients.invite.linkCreated": "تم إنشاء رابط الدعوة!",
  "clients.invite.linkCopiedToClipboard": "تم نسخ الرابط إلى الحافظة",
  "clients.invite.shareLink": "شارك هذا الرابط مع عميلك عبر البريد الإلكتروني أو الرسائل النصية أو شخصياً",
  "clients.invite.inviteAnother": "دعوة آخر",
  "clients.invite.success": "تمت دعوة العميل!",
  "clients.invite.linkCopied": "تم نسخ رابط الدعوة!",
  "clients.invite.yourAgent": "وكيلك",
  "clients.invite.defaultOffice": "مكتبنا",
  "deals.title": "الصفقات",
  "deals.subtitle": "تتبع وإدارة معاملاتك",
  "deals.create": "إنشاء صفقة",
  "deals.empty.title": "لا توجد صفقات بعد",
  "deals.empty.desc": "أنشئ صفقتك الأولى للبدء.",
  "deals.search": "البحث في الصفقات...",
  "deals.filter.all": "جميع الصفقات",
  "deals.filter.active": "نشطة",
  "deals.filter.pending": "قيد الانتظار",
  "deals.filter.closed": "مغلقة",
  "deals.column.draft": "مسودة",
  "deals.column.active": "نشطة",
  "deals.column.pending": "قيد الانتظار",
  "deals.column.closed": "مغلقة",
  "deals.card.documents": "{count} مستندات",
  "deals.card.messages": "{count} رسائل",
  "deals.dialog.title": "إنشاء صفقة جديدة",
  "deals.dialog.dealTitle": "عنوان الصفقة",
  "deals.dialog.dealTitlePlaceholder": "مثال: شراء سيارة - هوندا سيفيك 2023",
  "deals.dialog.client": "العميل",
  "deals.dialog.office": "المكتب الافتراضي",
  "deals.dialog.type": "نوع الصفقة",
  "deals.dialog.notes": "ملاحظات",
  "deals.dialog.notesPlaceholder": "أضف ملاحظات حول هذه الصفقة...",
  "deals.dialog.creating": "جاري الإنشاء...",
  "deals.dialog.create": "إنشاء الصفقة",
  "dealRoom.back": "العودة إلى الصفقات",
  "dealRoom.readOnly.title": "للقراءة فقط",
  "dealRoom.readOnly.closedMessage": "تم إغلاق هذه الصفقة. غرفة الصفقات الآن للقراءة فقط للمرجعية والتدقيق.",
  "dealRoom.readOnly.cancelledMessage": "تم إلغاء هذه الصفقة. غرفة الصفقات الآن للقراءة فقط للمرجعية والتدقيق.",
  "dealRoom.tabs.messages": "الرسائل",
  "dealRoom.tabs.documents": "المستندات",
  "dealRoom.tabs.contract": "العقد",
  "dealRoom.timeline.title": "الجدول الزمني للنشاط",
  "dealRoom.timeline.empty": "لا يوجد نشاط بعد",
  "dealRoom.details.title": "تفاصيل الصفقة",
  "dealRoom.details.notes": "ملاحظات",
  "dealRoom.details.type": "النوع",
  "dealRoom.details.documents": "المستندات",
  "dealRoom.details.messages": "الرسائل",
  "dealRoom.aiSummary.title": "ملخص الذكاء الاصطناعي",
  "dealRoom.aiSummary.generating": "جاري إنشاء الملخص...",
  "dealRoom.messages.empty": "لا توجد رسائل بعد. ابدأ المحادثة.",
  "dealRoom.messages.placeholder": "اكتب رسالة...",
  "dealRoom.messages.send": "إرسال",
  "dealRoom.messages.sending": "جاري الإرسال...",
  "dealRoom.messages.showOriginal": "عرض الأصلي",
  "dealRoom.messages.showTranslation": "عرض الترجمة",
  "dealRoom.messages.translatedFrom": "مترجم من {language}",
  "dealRoom.messages.suggestReply": "اقتراح رد",
  "dealRoom.documents.empty": "لم يتم تحميل أي مستندات بعد.",
  "dealRoom.documents.upload": "تحميل مستند",
  "dealRoom.documents.uploading": "جاري التحميل...",
  "dealRoom.documents.analyze": "تحليل",
  "dealRoom.documents.analyzing": "جاري التحليل...",
  "dealRoom.documents.download": "تنزيل",
  "dealRoom.documents.delete": "حذف",
  "dealRoom.documents.pending": "في انتظار التحليل",
  "dealRoom.documents.analyzed": "تم التحليل",
  "dealRoom.documents.aiAnalysis": "تحليل المستند بالذكاء الاصطناعي",
  "dealRoom.documents.type": "نوع المستند",
  "dealRoom.documents.confidence": "الثقة",
  "dealRoom.documents.summary": "ملخص",
  "dealRoom.documents.issues": "المشاكل",
  "dealRoom.contract.empty.title": "لم يتم إنشاء عقد بعد",
  "dealRoom.contract.empty.desc": "أنشئ مسودة عقد بالذكاء الاصطناعي لهذه الصفقة.",
  "dealRoom.contract.generate": "إنشاء مسودة العقد",
  "dealRoom.contract.regenerate": "إعادة إنشاء العقد",
  "dealRoom.contract.generating": "جاري الإنشاء...",
  "dealRoom.contract.aiLabel": "مسودة عقد مُنشأة بالذكاء الاصطناعي",
  "dealRoom.contract.language": "اللغة",
  "dealRoom.contract.copy": "نسخ",
  "dealRoom.contract.copied": "تم النسخ إلى الحافظة",
  "dealRoom.contract.type": "نوع العقد",
  "dealRoom.contract.generated": "تم الإنشاء",
  "dealRoom.contract.languages": "اللغات",
  "dealRoom.contract.status": "الحالة",
  "dealRoom.contract.notice": "تحليل المستند بالذكاء الاصطناعي: بند واحد أو أكثر ليس له مكافئ مباشر بين اللغات المختارة. استخدمنا لغة وصفية بدلاً من ذلك. يرجى مراجعة هذه الأقسام بعناية والتأكد مع الطرف الآخر إذا لزم الأمر.",
  "dealRoom.contract.dialog.title": "إنشاء مسودة العقد",
  "dealRoom.contract.dialog.desc": "سينشئ الذكاء الاصطناعي عقداً ثنائي اللغة بناءً على تفاصيل الصفقة.",
  "dealRoom.contract.dialog.disclaimer": "هذه مسودة مُنشأة بالذكاء الاصطناعي لأغراض المراجعة. اطلب من متخصص قانوني مراجعتها قبل التوقيع.",
  "dealRoom.contract.dialog.type": "نوع العقد",
  "dealRoom.contract.dialog.languages": "اللغات",
  "dealRoom.contract.dialog.languagesHelp": "اختر لغتين لعقدك ثنائي اللغة. جميع لغات المستوى الأول مدعومة بالكامل.",
  "dealRoom.contract.dialog.primary": "أساسي",
  "dealRoom.contract.dialog.secondary": "ثانوي",
  "dealRoom.contract.dialog.terms": "شروط خاصة",
  "dealRoom.contract.dialog.termsPlaceholder": "أضف أي شروط أو أحكام خاصة...",
  "dealRoom.contract.dialog.generate": "إنشاء العقد",
  "dealRoom.contract.dialog.generating": "جاري الإنشاء...",
  "dealRoom.status.change": "تغيير الحالة",
  "dealRoom.status.dialog.title": "تغيير حالة الصفقة",
  "dealRoom.status.dialog.from": "من",
  "dealRoom.status.dialog.to": "إلى",
  "dealRoom.status.dialog.reason": "السبب (اختياري)",
  "dealRoom.status.dialog.reasonPlaceholder": "لماذا تغير الحالة؟",
  "dealRoom.status.dialog.confirm": "تأكيد التغيير",
  "dealRoom.status.dialog.changing": "جاري التغيير...",
  "dealRoom.status.toast.changed": "تم تغيير الحالة إلى {status}",
  "dealRoom.upgrade.title": "الترقية إلى Business",
  "dealRoom.upgrade.desc": "إنشاء العقود يتطلب خطة Business.",
  "dealRoom.upgrade.features": "مع Business، تحصل على:",
  "dealRoom.upgrade.feature1": "مسودات عقود مُنشأة بالذكاء الاصطناعي",
  "dealRoom.upgrade.feature2": "تحليل متقدم للمستندات",
  "dealRoom.upgrade.feature3": "دعم ذو أولوية",
  "dealRoom.upgrade.button": "الترقية الآن",
  "settings.title": "الإعدادات",
  "settings.subtitle": "إدارة حسابك ومؤسستك",
  "settings.tabs.profile": "الملف الشخصي",
  "settings.tabs.organization": "المؤسسة",
  "settings.profile.title": "إعدادات الملف الشخصي",
  "settings.profile.subtitle": "إدارة معلوماتك الشخصية",
  "settings.profile.name": "الاسم الكامل",
  "settings.profile.email": "البريد الإلكتروني",
  "settings.profile.emailNote": "لا يمكن تغيير البريد الإلكتروني",
  "settings.profile.language": "اللغة المفضلة",
  "settings.profile.languageHelp": "ستُعرض جميع واجهة المستخدم والرسائل والعقود بهذه اللغة.",
  "settings.profile.save": "حفظ التغييرات",
  "settings.profile.saving": "جاري الحفظ...",
  "settings.profile.saved": "تم تحديث الملف الشخصي",
  "settings.org.title": "إعدادات المؤسسة",
  "settings.org.subtitle": "إدارة معلومات عملك",
  "settings.org.name": "اسم المؤسسة",
  "settings.org.type": "نوع الصناعة",
  "settings.org.billingEmail": "بريد الفواتير",
  "settings.org.plan": "الخطة",
  "settings.org.verification": "حالة التحقق",
  "settings.org.save": "حفظ التغييرات",
  "settings.org.saving": "جاري الحفظ...",
  "settings.org.saved": "تم تحديث المؤسسة",
  "settings.org.noOrg": "لم يتم العثور على مؤسسة",
  "invite.language.title": "اختر لغتك",
  "invite.language.subtitle": "سنعرض جميع التعليمات بلغتك.",
  "invite.welcome.title": "مرحباً بك في",
  "invite.welcome.subtitle": "نحن مستعدون لاستلام مستنداتك.",
  "invite.welcome.time": "5-10 دقائق",
  "invite.welcome.timeLabel": "الوقت المقدر",
  "invite.welcome.secure": "آمن ومجاني",
  "invite.welcome.secureDesc": "مستنداتك مشفرة. هذه الخدمة مجانية لك.",
  "invite.welcome.start": "بدء التحميل",
  "invite.documents.needed": "المستندات المطلوبة",
  "invite.upload.title": "تحميل مستند",
  "invite.upload.dragDrop": "اسحب وأفلت ملفاً هنا، أو انقر للاختيار",
  "invite.upload.or": "أو",
  "invite.upload.takePhoto": "الصور",
  "invite.upload.browse": "الملفات",
  "invite.upload.uploading": "جاري التحميل...",
  "invite.upload.analyzing": "جاري فحص المستند...",
  "invite.upload.success": "تم التحميل بنجاح",
  "invite.upload.next": "المستند التالي",
  "invite.upload.finish": "مراجعة الكل",
  "invite.upload.skip": "تخطي الآن",
  "invite.upload.progress": "التقدم",
  "invite.complete.title": "تم!",
  "invite.complete.subtitle": "تم إرسال مستنداتك بنجاح.",
  "invite.complete.message": "استلمنا جميع مستنداتك. سيتم التواصل معك قريباً.",
  "invite.complete.summary": "المستندات المرسلة",
  "invite.complete.securityNote": "مستنداتك مخزنة بأمان ولن يصل إليها إلا الموظفون المصرح لهم.",
  "invite.chat.title": "محادثة مع وكيلك",
  "invite.chat.placeholder": "اكتب رسالة...",
  "invite.chat.empty": "لا توجد رسائل بعد. ابدأ محادثة.",
  "invite.chat.sent": "تم إرسال رسالتك.",
  "invite.chat.willRespond": "سنرد في أقرب وقت ممكن.",
  "invite.chat.sending": "جاري الإرسال...",
  "invite.error.title": "رابط غير صالح أو منتهي الصلاحية",
  "invite.error.message": "رابط الدعوة هذا لم يعد صالحاً. يرجى التواصل مع المرسل للحصول على رابط جديد.",
  "common.loading": "جاري التحميل...",
  "common.save": "حفظ",
  "common.cancel": "إلغاء",
  "common.delete": "حذف",
  "common.edit": "تعديل",
  "common.create": "إنشاء",
  "common.close": "إغلاق",
  "common.dismiss": "إغلاق",
  "common.confirm": "تأكيد",
  "common.back": "رجوع",
  "common.next": "التالي",
  "common.previous": "السابق",
  "common.of": "من",
  "common.search": "بحث",
  "common.filter": "تصفية",
  "common.sort": "ترتيب",
  "common.viewAll": "عرض الكل",
  "common.refresh": "تحديث",
  "common.retry": "إعادة المحاولة",
  "common.yes": "نعم",
  "common.no": "لا",
  "common.or": "أو",
  "common.and": "و",
  "common.optional": "اختياري",
  "common.required": "مطلوب",
  "status.draft": "مسودة",
  "status.active": "نشطة",
  "status.pending": "قيد الانتظار",
  "status.pending_documents": "في انتظار المستندات",
  "status.pending_signature": "في انتظار التوقيع",
  "status.on_hold": "معلقة",
  "status.closed": "مغلقة",
  "status.cancelled": "ملغاة",
  "error.generic": "حدث خطأ. يرجى المحاولة مرة أخرى.",
  "error.network": "خطأ في الشبكة. يرجى التحقق من اتصالك.",
  "error.unauthorized": "غير مصرح لك بتنفيذ هذا الإجراء.",
  "error.notFound": "لم يتم العثور على المورد المطلوب.",
  "error.validation": "يرجى التحقق من إدخالك والمحاولة مرة أخرى.",
  "error.serverError": "خطأ في الخادم. يرجى المحاولة لاحقاً.",
  "success.saved": "تم حفظ التغييرات بنجاح.",
  "success.created": "تم الإنشاء بنجاح.",
  "success.deleted": "تم الحذف بنجاح.",
  "success.sent": "تم الإرسال بنجاح.",
  "success.uploaded": "تم التحميل بنجاح.",
  "time.justNow": "الآن",
  "time.minutesAgo": "منذ {count} دقائق",
  "time.hoursAgo": "منذ {count} ساعات",
  "time.daysAgo": "منذ {count} أيام",
  "time.today": "اليوم",
  "time.yesterday": "أمس",
  "dealRoom.notFound": "لم يتم العثور على الصفقة",
  "dealRoom.loading": "جاري تحميل الصفقة...",
  "dealRoom.conversation.title": "محادثة الصفقة",
  "dealRoom.conversation.you": "أنت",
  "dealRoom.conversation.client": "العميل",
  "dealRoom.messages.hideOriginal": "إخفاء الأصلي",
  "dealRoom.messages.original": "الأصلي ({language})",
  "dealRoom.messages.disabled": "الرسائل معطلة لهذه الحالة",
  "dealRoom.messages.aiSuggest": "رد مقترح من الذكاء الاصطناعي",
  "dealRoom.documents.title": "المستندات",
  "dealRoom.documents.uploadDisabled": "التحميل معطل",
  "dealRoom.documents.pendingAnalysis": "في انتظار التحليل",
  "dealRoom.documents.uploadFirst": "تحميل المستند الأول",
  "dealRoom.documents.uploadHelp": "حمّل المستندات لهذه الصفقة لتحليل الذكاء الاصطناعي",
  "dealRoom.documents.uploadDisabledHelp": "تحميل المستندات معطل لهذه الحالة",
  "dealRoom.documents.analyzeWithAI": "تحليل بالذكاء الاصطناعي",
  "dealRoom.documents.notAnalyzed": "لم يتم التحليل بعد",
  "dealRoom.documents.notAnalyzedHelp": "شغّل تحليل الذكاء الاصطناعي لاستخراج نوع المستند والحقول والحصول على رؤى",
  "dealRoom.documents.analyzeDocument": "تحليل المستند",
  "dealRoom.documents.extractedFields": "الحقول المستخرجة",
  "dealRoom.documents.issuesDetected": "المشاكل المكتشفة",
  "dealRoom.documents.preview": "معاينة",
  "dealRoom.documents.uploaded": "تم التحميل",
  "dealRoom.documents.deleteConfirm": "هل أنت متأكد أنك تريد حذف هذا المستند؟",
  "dealRoom.onHold.message": "هذه الصفقة معلقة. تحميل المستندات معطل. لا يزال بإمكانك إرسال رسائل للتنسيق.",
  "dealRoom.pendingSignature.message": "العقد جاهز للتوقيع. تحميل المستندات معطل حتى يتم توقيع العقد أو إرجاعه.",
  "dealRoom.status.current": "حالي",
  "dealRoom.status.finalWarning": "هذه حالة نهائية. لا يمكن إعادة فتح الصفقة بعد هذا الإجراء.",
  "dealRoom.contract.purchaseAgreement": "اتفاقية الشراء",
  "dealRoom.contract.purchaseAgreementDesc": "عقد اتفاقية شراء قياسي",
  "dealRoom.contract.noContract": "لا يوجد عقد بعد",
  "dealRoom.contract.noContractDesc": "أنشئ مسودة عقد مدعومة بالذكاء الاصطناعي بناءً على تفاصيل ومستندات صفقتك.",
  "dealRoom.contract.notAvailable": "إنشاء العقود غير متاح لصفقات {status}.",
  "dealRoom.contract.locked": "إنشاء العقود مقفل أثناء انتظار التوقيع.",
  "dealRoom.contract.requiresPlan": "يتطلب خطة Business Starter",
  "dealRoom.toast.dealUpdated": "تم تحديث الصفقة",
  "dealRoom.toast.statusChanged": "تم تغيير حالة الصفقة إلى {status}",
  "dealRoom.toast.statusFailed": "فشل في تغيير الحالة",
  "dealRoom.toast.contractGenerated": "تم إنشاء مسودة العقد بنجاح",
  "dealRoom.toast.contractCopied": "تم نسخ عقد {language} إلى الحافظة",
  "dealRoom.toast.messageFailed": "فشل في إرسال الرسالة",
  "dealRoom.toast.suggestionFailed": "فشل في إنشاء الاقتراح",
  "dealRoom.toast.documentUploaded": "تم تحميل المستند",
  "dealRoom.toast.uploadFailed": "فشل التحميل",
  "dealRoom.toast.analysisComplete": "اكتمل تحليل المستند بالذكاء الاصطناعي",
  "dealRoom.toast.analysisFailed": "فشل تحليل الذكاء الاصطناعي",
  "dealRoom.toast.documentDeleted": "تم حذف المستند",
  "dealRoom.toast.deleteFailed": "فشل الحذف",
  "dealRoom.details.created": "تم الإنشاء",
  "dealRoom.details.addNotes": "إضافة ملاحظات الصفقة...",
  "onboarding.brand": "PocketFiler",
  "onboarding.skip": "تخطي الآن",
  "onboarding.badge": "إعداد مدعوم بالذكاء الاصطناعي",
  "onboarding.welcome": "مرحباً، {name}!",
  "onboarding.welcomeGeneric": "مرحباً!",
  "onboarding.subtitle": "لنُعد مساحة عمل PocketFiler الخاصة بك. أخبر مساعد الذكاء الاصطناعي عن عملك، وسنُعد كل شيء لك.",
  "onboarding.step1": "صف عملك واحتياجاتك",
  "onboarding.step2": "الذكاء الاصطناعي يقترح إعدادك",
  "onboarding.step3": "ابدأ بإدارة الصفقات",
  "onboarding.concierge.title": "مساعد الذكاء الاصطناعي",
  "onboarding.toast.officeCreated": "تم إنشاء المكتب الافتراضي!",
  "auth.signup.accountType": "نوع الحساب",
  "auth.signup.passwordTooShort": "يجب أن تكون كلمة المرور 8 أحرف على الأقل",
  "auth.signup.passwordsDoNotMatch": "كلمات المرور غير متطابقة",
  "auth.signup.success": "تم إنشاء الحساب بنجاح!",
  "captions.connecting": "جار الاتصال...",
  "captions.disable": "إلغاء الترجمة",
  "captions.enable": "تفعيل الترجمة",
  "captions.error.connect": "فشل في الاتصال بخدمة الترجمة",
  "captions.error.toggle": "فشل في تبديل الترجمة",
  "captions.language": "لغة الترجمة",
  "captions.live": "مباشر",
  "captions.off": "الترجمة معطلة",
  "captions.on": "الترجمة مفعلة",
  "captions.original": "الأصلي",
  "captions.translated": "مترجم",
  "captions.translating": "جار الترجمة...",
  "clients.joined.empty.desc": "لم تنضم بعد لأي منظمات. اطلب منهم دعوتك إلى مساحة عمل PocketFiler.",
  "clients.joined.empty.title": "لم تنضم لأي منظمات",
  "clients.nav.joinedOrgs": "المنظمات المنضمة إليها",
  "clients.nav.myClients": "عملائي",
  "clients.table.joinedDate": "تاريخ الانضمام",
  "clients.table.organization": "المنظمة",
  "common.backToHome": "العودة للرئيسية",
  "common.deleteConfirmDesc": "لا يمكن التراجع عن هذا الإجراء. سيتم حذف العنصر نهائياً وإزالة البيانات من خوادمنا.",
  "common.deleteConfirmTitle": "هل أنت متأكد تماماً؟",
  "common.noResults": "لم يتم العثور على نتائج",
  "connect.createAccount": "إنشاء حساب مجاني",
  "connect.dealCreated": "تم إنشاء الصفقة بنجاح",
  "connect.error.invalid": "رابط اتصال غير صحيح",
  "connect.error.invalidDesc": "رابط الاتصال هذا غير صحيح أو منتهي الصلاحية.",
  "connect.error.server": "حدث خطأ ما",
  "connect.error.serverDesc": "يرجى المحاولة مرة أخرى لاحقاً.",
  "connect.infoUnauth": "هذا الشخص يستخدم PocketFiler لإدارة الصفقات والمستندات متعددة اللغات بأمان.",
  "connect.joinOffice": "الانضمام للمكتب الافتراضي",
  "connect.loggedInAs": "مسجل دخول كـ",
  "connect.login": "تسجيل الدخول",
  "connect.startDeal": "بدء صفقة",
  "connect.titleAuth": "أنت تتصل بـ",
  "connect.titleUnauth": "اتصل بـ",
  "connect.typeOrg": "منظمة",
  "connect.typePerson": "شخص",
  "contacts.actions.call": "اتصال",
  "contacts.actions.email": "بريد إلكتروني",
  "contacts.actions.message": "إرسال رسالة داخل التطبيق",
  "contacts.actions.noEmail": "لا يوجد عنوان بريد إلكتروني",
  "contacts.actions.noPhone": "لا يوجد رقم هاتف",
  "contacts.actions.sms": "رسالة نصية",
  "contacts.actions.title": "التواصل مع {name}",
  "contacts.actions.whatsapp": "واتساب",
  "contacts.dialog.name": "اسم جهة الاتصال",
  "contacts.dialog.title": "إضافة جهة اتصال جديدة",
  "contacts.empty.desc": "أضف جهة الاتصال الأولى للبدء.",
  "contacts.empty.title": "لا توجد جهات اتصال بعد",
  "contacts.invite": "إضافة جهة اتصال",
  "contacts.invite.customNotePlaceholder": "أي ملاحظات خاصة حول جهة الاتصال هذه...",
  "contacts.invite.nameLabel": "اسم جهة الاتصال",
  "contacts.invite.shareLink": "شارك هذا الرابط مع جهة الاتصال عبر البريد الإلكتروني أو الرسائل النصية أو شخصياً",
  "contacts.invite.step1Desc": "أدخل معلومات جهة الاتصال",
  "contacts.invite.step1Title": "إضافة جهة اتصال جديدة",
  "contacts.subtitle": "إدارة جهات الاتصال والدعوات",
  "contacts.table.contact": "جهة الاتصال",
  "contacts.title": "جهات الاتصال",
  "contacts.toast.deleted": "تم حذف جهة الاتصال",
  "contacts.toast.invited": "تم إضافة جهة الاتصال: {name}",
  "contacts.toast.linkCopied": "تم نسخ الرابط إلى الحافظة",
  "dashboard.quickActions.inviteContact": "إضافة جهة اتصال",
  "dashboard.recentContacts.empty": "لا توجد جهات اتصال بعد. ادع جهة الاتصال الأولى للبدء.",
  "dashboard.recentContacts.title": "جهات الاتصال الحديثة",
  "dashboard.recentContacts.viewAll": "عرض الجميع",
  "dashboard.stats.totalContacts": "إجمالي جهات الاتصال",
  "dealRoom.contract.analysisWarning": "لم يتم تحليل بعض المستندات بعد. التحليل بالذكاء الاصطناعي يحسن دقة العقد.",
  "dealRoom.conversation.colleague": "زميل",
  "dealRoom.details.clients": "العملاء",
  "dealRoom.documents.previewNotAvailable": "المعاينة غير متاحة. جار التحميل...",
  "dealRoom.incomingCall.accept": "قبول",
  "dealRoom.incomingCall.decline": "رفض",
  "dealRoom.incomingCall.inProgress": "مكالمة جارية",
  "dealRoom.incomingCall.started": "{name} بدأ مكالمة",
  "dealRoom.messages.connecting": "جار الاتصال بالمحادثة...",
  "dealRoom.messages.connectionError": "غير قادر على الاتصال بالمحادثة.",
  "dealRoom.pendingSignature.loading": "جار تحميل حالة التوقيع...",
  "dealRoom.pendingSignature.signedWaitingOthers": "تم التوقيع بنجاح. في انتظار المشاركين الآخرين.",
  "dealRoom.readOnly.completedMessage": "تم إتمام هذه الصفقة بنجاح. غرفة الصفقة الآن للقراءة فقط لأغراض المرجع والمراجعة.",
  "dealRoom.signature.signed": "موقع",
  "dealRoom.signature.signedByYou": "موقع منك",
  "dealRoom.signature.success": "تم توقيع العقد بنجاح!",
  "dealRoom.signaturesList.clients": "العملاء",
  "dealRoom.signaturesList.dealOwner": "مالك الصفقة",
  "dealRoom.signaturesList.pending": "في الانتظار",
  "dealRoom.signaturesList.signedOn": "تم التوقيع في",
  "dealRoom.signaturesList.title": "التوقيعات",
  "dealRoom.signaturesList.viewSignatures": "عرض التوقيعات",
  "dealRoom.signedByAll.addPayment": "إضافة دفعة",
  "dealRoom.signedByAll.message": "تم التوقيع من جميع المشاركين. المتابعة للدفع.",
  "dealRoom.timeline.createdBy": "بواسطة {name}",
  "deals.tabs.all": "جميع الصفقات",
  "deals.tabs.my": "صفقاتي",
  "deals.validation.clientRequired": "يرجى اختيار عميل واحد على الأقل",
  "deals.validation.notesLength": "يجب أن تكون الملاحظات 200 حرف أو أقل",
  "deals.validation.titleLength": "يجب أن يكون العنوان 100 حرف أو أقل",
  "deals.validation.titleRequired": "عنوان الصفقة مطلوب",
  "documents.readAloud.analyzeFirst": "حلل هذا المستند أولاً لقراءته بصوت عالٍ.",
  "documents.readAloud.error": "فشلت القراءة بصوت عالٍ",
  "documents.readAloud.title": "قراءة بصوت عالٍ",
  "landing.cta.secondary": "عرض غرفة صفقة تجريبية",
  "landing.hero.trust": "خطة مجانية. لا حاجة لبطاقة ائتمان. يدعم 11 لغة.",
  "landing.socialProof": "يثق بنا أكثر من 500 شركة في 40 دولة",
  "landing.useCases.personal.desc": "أتمم الصفقات المهمة مثل المركبات والمعدات أو العقارات مع سجلات واضحة وعقود بالذكاء الاصطناعي وروابط آمنة بسيطة لمشاركة المستندات.",
  "landing.useCases.personal.title": "المعاملات الشخصية عالية القيمة",
  "landing.useCases.professional.desc": "ادع العملاء لرفع المستندات بمساعدة الذكاء الاصطناعي، تتبع كل تفاعل في المكاتب الافتراضية الآمنة، وأنشئ عقود رقمية ثنائية اللغة - كل ذلك من مساحة عمل واحدة.",
  "landing.useCases.professional.subtitle": "التأمين، العقارات، الإقراض",
  "landing.useCases.professional.title": "الخدمات المهنية",
  "livekit.call": "مكالمة",
  "livekit.connecting": "جار الاتصال...",
  "livekit.error.connect": "فشل في الاتصال بالمكالمة. يرجى المحاولة مرة أخرى.",
  "livekit.error.connection": "خطأ في الاتصال. يرجى التحقق من شبكتك والمحاولة مرة أخرى.",
  "livekit.error.permission": "ليس لديك صلاحية للانضمام لهذه المكالمة.",
  "livekit.hint": "تحدث داخل هذه الصفقة بدلاً من تغيير التطبيقات.",
  "livekit.inCall": "في المكالمة",
  "livekit.joinCall": "الانضمام للمكالمة",
  "livekit.leaveCall": "مغادرة المكالمة",
  "livekit.participant": "مشارك",
  "livekit.participants": "مشاركين",
  "messages.readAloud.error": "فشلت القراءة بصوت عالٍ",
  "messages.readAloud.title": "قراءة بصوت عالٍ",
  "nav.companyProfile": "الملف التجاري",
  "nav.contacts": "جهات الاتصال",
  "nav.directory": "الدليل",
  "nav.products": "المنتجات",
  "offices.card.contacts": "{count} جهات اتصال",
  "pwa.banner.install": "تثبيت",
  "pwa.banner.subtitle": "وصول أسرع، يعمل بدون إنترنت",
  "pwa.banner.title": "احصل على تطبيق PocketFiler",
  "pwa.firefox.hint": "في فايرفوكس، ابحث عن أيقونة التثبيت (⊕) في شريط العناوين لإضافة هذا التطبيق إلى سطح المكتب.",
  "pwa.installApp": "تثبيت التطبيق",
  "pwa.installed": "تم تثبيت التطبيق بنجاح!",
  "pwa.ios.description": "أضف PocketFiler إلى شاشتك الرئيسية للحصول على أفضل تجربة:",
  "pwa.ios.gotIt": "فهمت",
  "pwa.ios.inToolbar": "في شريط أدوات المتصفح",
  "pwa.ios.inTopRight": "في الزاوية اليمنى العلوية",
  "pwa.ios.shareButton": "زر المشاركة",
  "pwa.ios.step1": "انقر على",
  "pwa.ios.step2": "مرر لأسفل وانقر على",
  "pwa.ios.step3": "انقر على",
  "pwa.ios.title": "تثبيت PocketFiler",
  "pwa.iosHint": "انقر على أيقونة المشاركة و\\\"إضافة إلى الشاشة الرئيسية\\\" لتثبيت PocketFiler.",
  "pwa.opera.chromeHint": "افتح هذه الصفحة، ثم انقر على أيقونة التثبيت في شريط العناوين",
  "pwa.opera.desktopNotSupported": "أوبرا لسطح المكتب لا يدعم تثبيت PWA. لتثبيت PocketFiler كتطبيق، يرجى فتحه في جوجل كروم أو مايكروسوفت إيدج.",
  "pwa.opera.edgeHint": "افتح هذه الصفحة، ثم انقر على أيقونة التثبيت (⊕) في شريط العناوين",
  "pwa.opera.mobileAddPage": "إضافة صفحة إلى",
  "pwa.opera.mobileDescription": "انقر على أيقونة + في أسفل أوبرا، أو استخدم القائمة أدناه:",
  "pwa.opera.mobileHomeScreen": "الشاشة الرئيسية",
  "pwa.opera.mobileStep1": "انقر على",
  "pwa.opera.mobileStep1b": "أيقونة الزائد (+) في الشريط السفلي لأوبرا",
  "pwa.opera.mobileStep2": "أو انقر على",
  "pwa.opera.mobileTitle": "تثبيت PocketFiler في أوبرا",
  "pwa.opera.recommendedBrowsers": "استخدم بدلاً من ذلك:",
  "pwa.opera.title": "غير متاح في أوبرا",
  "qr.clickToExpand": "انقر لعرض ملء الشاشة",
  "qr.copied": "تم النسخ!",
  "qr.copyLink": "نسخ الرابط",
  "qr.description": "اعرض هذا الرمز للعملاء أو الشركاء. عندما يقومون بمسحه، يمكنهم التواصل معك وبدء صفقة خلال ثوانٍ.",
  "qr.download": "تحميل",
  "qr.generate": "إنشاء رمز QR",
  "qr.linkCopied": "تم نسخ الرابط إلى الحافظة",
  "qr.primaryLanguage": "اللغة الأساسية",
  "qr.regenerate": "إعادة تعيين",
  "qr.regenerated": "تم تجديد رمز QR. الروابط القديمة غير صالحة الآن.",
  "qr.scanInstructions": "امسح هذا الرمز باستخدام PocketFiler أو أي ماسح QR للاتصال.",
  "qr.scanToConnect": "امسح للاتصال",
  "qr.share": "مشاركة",
  "qr.title": "مشاركة رمز PocketFiler الخاص بك",
  "qr.yourLink": "رابط الاتصال الخاص بك:",
  "recording.completed": "اكتمل التسجيل",
  "recording.confirmDelete": "حذف هذا التسجيل؟",
  "recording.delete": "حذف",
  "recording.deleted": "تم حذف التسجيل",
  "recording.download": "تحميل",
  "recording.error.delete": "فشل في حذف التسجيل",
  "recording.error.noCall": "لا توجد مكالمة نشطة. يرجى الانضمام للمكالمة أولاً.",
  "recording.error.start": "فشل في بدء التسجيل",
  "recording.error.stop": "فشل في إيقاف التسجيل",
  "recording.failed": "فشل التسجيل",
  "recording.noRecordings": "لا توجد تسجيلات بعد",
  "recording.play": "تشغيل",
  "recording.playback": "تشغيل التسجيل",
  "recording.processing": "جار المعالجة...",
  "recording.start": "تسجيل",
  "recording.started": "بدأ التسجيل",
  "recording.stop": "إيقاف",
  "recording.stopped": "توقف التسجيل. جار المعالجة...",
  "recording.viewRecordings": "عرض التسجيلات",
  "schedule.button": "جدولة",
  "schedule.cancel": "إلغاء",
  "schedule.chooseDateTime": "يرجى اختيار التاريخ والوقت",
  "schedule.create": "جدولة",
  "schedule.created": "تم الجدولة",
  "schedule.dateTime": "التاريخ والوقت",
  "schedule.description": "اختر التاريخ والوقت. يمكنك الانضمام للمكالمة في الوقت المحدد.",
  "schedule.title": "جدولة مكالمة أو تسجيل",
  "schedule.type": "النوع",
  "schedule.typeCall": "مكالمة",
  "schedule.typeRecording": "تسجيل",
  "schedule.upcoming": "المجدولة القادمة",
  "settings.profile.accountType": "نوع الحساب",
  "settings.profile.accountTypeHelp": "اختر النوع الذي يصفك بشكل أفضل",
  "settings.tabs.sharing": "مشاركة رمز QR",
  "support.askAI": "اسأل الذكاء الاصطناعي",
  "support.availableTimes": "الأوقات المتاحة",
  "support.booked": "تم جدولة المكالمة بنجاح!",
  "support.bookingConfirmed": "رائع، لقد جدولت مكالمتك لـ {time}. ستتلقى تأكيداً مع رابط المكالمة. هل هناك أي شيء آخر يمكنني مساعدتك فيه؟",
  "support.bookingError": "فشل في حجز الموعد. يرجى المحاولة مرة أخرى.",
  "support.clearChat": "مسح المحادثة",
  "support.error": "فشل في إرسال الرسالة. يرجى المحاولة مرة أخرى.",
  "support.inYourTime": "بتوقيتك المحلي",
  "support.inputPlaceholder": "اكتب سؤالك...",
  "support.openChat": "فتح دعم الذكاء الاصطناعي",
  "support.scheduleCall": "جدولة مكالمة مع الدعم",
  "support.scheduleTitle": "جدولة مكالمة دعم",
  "support.slotsError": "فشل في تحميل الأوقات المتاحة.",
  "support.subtitle": "اسأل أي شيء حول PocketFiler",
  "support.title": "الدعم بالذكاء الاصطناعي",
  "support.welcome": "مرحباً! أنا مساعد PocketFiler الذكي. يمكنني مساعدتك في:\\n\\n- إنشاء وإدارة الصفقات\\n- إرسال المستندات للتوقيع\\n- استخدام خاصية الاتصال بـ QR\\n- دعوة العملاء\\n- أي أسئلة أخرى حول PocketFiler\\n\\nكيف يمكنني مساعدتك اليوم؟",
  "support.yourTimezone": "منطقتك الزمنية",
  "validation.emailInvalid": "تنسيق البريد الإلكتروني غير صحيح",
  "validation.emailRequired": "البريد الإلكتروني مطلوب",
  "validation.nameRequired": "الاسم مطلوب",
  "validation.nameTooLong": "يجب أن يكون الاسم أقل من 50 حرف",
  "validation.noteTooLong": "يجب أن تكون الملاحظة أقل من 200 حرف",
  "validation.phoneInvalid": "رقم هاتف غير صحيح (10-15 رقم)",
  "validation.phoneRequired": "رقم الهاتف مطلوب",
  "deals.column.cancelled": "ملغى",
  "deals.column.completed": "مكتمل",
  "deals.column.disputed": "متنازع عليه",
  "deals.column.escrow_funded": "تم تمويل الضمان",
  "deals.column.on_hold": "معلق",
  "deals.column.pending_documents": "في انتظار المستندات",
  "deals.column.pending_payment": "في انتظار الدفع",
  "deals.column.pending_signature": "في انتظار التوقيع",
  "deals.column.release_requested": "طلب الإفراج",
  "dashboard.actions.addClient": "إضافة عميل",
  "dashboard.actions.all": "الكل",
  "dashboard.actions.createContract": "إنشاء عقد",
  "dashboard.actions.createInvoice": "إنشاء فاتورة",
  "dashboard.actions.customize": "تخصيص",
  "dashboard.actions.newDeal": "صفقة جديدة",
  "dashboard.actions.scheduleMeeting": "جدولة اجتماع",
  "dashboard.actions.uploadDocument": "رفع مستند",
  "dashboard.actions.viewAll": "عرض الكل",
  "dashboard.briefing.default": "لا يوجد شيء عاجل الآن. مساحة العمل الخاصة بك في حالة جيدة.",
  "dashboard.briefing.title": "الإحاطة اليومية",
  "dashboard.empty.activity": "لا يوجد نشاط حديث.",
  "dashboard.empty.deals": "لا توجد صفقات بعد. أنشئ صفقتك الأولى لرؤية خط الصفقات.",
  "dashboard.empty.documents": "جميع المستندات محدثة.",
  "dashboard.empty.meetings": "لا توجد اجتماعات قادمة.",
  "dashboard.empty.tasks": "لا توجد مهام مفتوحة.",
  "dashboard.greeting.afternoon": "مساء الخير",
  "dashboard.greeting.evening": "مساء الخير",
  "dashboard.greeting.morning": "صباح الخير",
  "dashboard.greeting.subtitle": "إليك ما يحدث في مساحة العمل الخاصة بك.",
  "dashboard.stats.documents": "المستندات",
  "dashboard.stats.invoicesDue": "الفواتير المستحقة",
  "dashboard.stats.meetingsComing": "الاجتماعات القادمة",
  "dashboard.stats.tasksDue": "المهام المستحقة",
  "dashboard.stats.unreadMessages": "الرسائل غير المقروءة",
  "dashboard.widgets.dealPipeline": "خط الصفقات",
  "dashboard.widgets.documentsAttention": "المستندات التي تحتاج انتباه",
  "dashboard.widgets.gettingStarted": "البدء",
  "dashboard.widgets.quickActions": "الإجراءات السريعة",
  "dashboard.widgets.recentActivity": "النشاط الأخير",
  "dashboard.widgets.tasks": "المهام",
  "dashboard.widgets.upcomingMeetings": "الاجتماعات القادمة",
  "dashboard.steps.createDeal": "أنشئ أول صفقة لك",
  "dashboard.steps.addClient": "إضافة عميل",
  "dashboard.steps.uploadDocument": "رفع مستند",
  "dashboard.steps.scheduleMeeting": "جدولة اجتماع",
  "dashboard.steps.createInvoice": "إنشاء فاتورة",
  "dashboard.steps.addLogo": "إضافة شعارك",
  "dashboard.steps.complete": "مكتمل",
  "dashboard.time.overdue": "متأخر",
  "dashboard.time.today": "اليوم",
  "dashboard.time.tomorrow": "غداً",
  "dashboard.time.noDate": "بدون تاريخ",
  "dashboard.docReason.sent": "مرسل، في انتظار الرد",
  "dashboard.docReason.notAnalyzed": "لم يتم تحليله بعد",
  "dashboard.docReason.draft": "مسودة، غير نهائي",
  "dashboard.docReason.needsReview": "يحتاج مراجعة",
  "docViewer.notFound": "لم يتم العثور على الوثيقة",
  "docViewer.previewUnavailable": "المعاينة غير متاحة لهذا النوع من الملفات",
  "docViewer.aiAnalysis": "تحليل الذكاء الاصطناعي",
  "docViewer.documentType": "نوع الوثيقة",
  "docViewer.summary": "الملخص",
  "docViewer.extractedFields": "الحقول المستخرجة",
  "docViewer.issues": "المشاكل",
  "docViewer.tags": "العلامات",
  "docViewer.noPreviousVersions": "لا توجد إصدارات سابقة",
  "docViewer.noActivity": "لا توجد أنشطة بعد",
  "auth.forgotPassword.title": "إعادة تعيين كلمة المرور",
  "guestSign.loading": "جارٍ تحميل العقد...",
  "guestSign.unableToLoad": "تعذر تحميل العقد",
  "guestSign.signed": "تم توقيع العقد",
  "guestSign.createOwn": "هل تريد إنشاء وإدارة عقودك الخاصة؟",
  "guestSign.secureSign": "التوقيع الآمن",
  "meeting.ended": "انتهى هذا الاجتماع",
  "meeting.cancelled": "تم إلغاء الاجتماع",
  "meeting.notFound": "لم يتم العثور على الاجتماع",
  "meeting.joiningAs": "الانضمام باسم",
  "meeting.yourName": "اسمك *",
  "meeting.emailOptional": "البريد الإلكتروني (اختياري)",
  "notFound.title": "لم يتم العثور على الصفحة",
  "notFound.dashboard": "الذهاب إلى لوحة المعلومات",
  "notFound.home": "الرئيسية",
  "auth.resetPassword.invalidLink": "رابط غير صالح",
  "auth.resetPassword.title": "تعيين كلمة مرور جديدة",
  "templates.category": "الفئة",
  "templates.legal": "قانونية",
  "templates.sales": "المبيعات",
  "templates.services": "الخدمات",
  "templates.finance": "المالية",
  "templates.library": "مكتبة القوالب",
  "templates.libraryDesc": "قوالب الوثائق الجاهزة للاستخدام لشركتك",
  "templates.noDefault": "لا توجد قوالب افتراضية تطابق بحثك.",
  "templates.noCustom": "لم يتم العثور على قوالب مخصصة",
  "templates.delete": "حذف القالب",
  "templates.cancel": "إلغاء",
  "uploadRequest.notFound": "لم يتم العثور على الطلب",
  "uploadRequest.error": "حدث خطأ ما",
  "uploadRequest.errorDesc": "يرجى المحاولة مرة أخرى لاحقاً أو التواصل مع الشخص الذي أرسل هذا الطلب.",
  "uploadRequest.uploaded": "تم رفع الوثائق!",
  "uploadRequest.title": "طلب رفع الوثائق",
  "uploadRequest.fileTypes": "ملفات PDF والصور ووثائق Word - حد أقصى 25 ميجابايت",
  "verify.verifying": "جارٍ التحقق من بريدك الإلكتروني...",
  "verify.success": "تم التحقق من البريد الإلكتروني!",
  "verify.signIn": "تسجيل الدخول",
  "verify.alreadyVerified": "تم التحقق مسبقاً",
  "verify.invalidLink": "رابط غير صالح",
  "verify.backToLogin": "العودة إلى تسجيل الدخول",
  "documents.documents": "الوثائق",
  "documents.allStatus": "جميع الحالات",
  "documents.newFolder": "مجلد جديد",
  "documents.clear": "مسح",
  "documents.noDocumentsYet": "لا توجد وثائق بعد",
  "documents.status": "الحالة",
  "documents.type": "النوع",
  "documents.uploadedBy": "تم الرفع بواسطة",
  "documents.previewNotAvailable": "المعاينة غير متاحة",
  "documents.aiAnalysis": "تحليل AI",
  "documents.documentType": "نوع الوثيقة",
  "documents.summary": "الملخص",
  "documents.extractedFields": "الحقول المستخرجة",
  "documents.issues": "المشاكل",
  "documents.notYetAnalyzed": "لم يتم التحليل بعد",
  "documents.details": "التفاصيل",
  "documents.size": "الحجم",
  "documents.date": "التاريخ",
  "documents.mimeType": "نوع MIME",
  "documents.noTags": "لا توجد علامات",
  "documents.changeStatus": "تغيير الحالة",
  "documents.versionHistory": "سجل الإصدارات",
  "documents.noPreviousVersions": "لا توجد إصدارات سابقة",
  "documents.activityLog": "سجل النشاط",
  "documents.noActivityRecordedYet": "لم يتم تسجيل أي نشاط بعد",
  "documents.uploadDocuments": "رفع الوثائق",
  "documents.dragAndDropFiles": "اسحب وأفلت الملفات أو انقر للتصفح. يدعم PDF والصور ووثائق Word.",
  "documents.shareDocument": "مشاركة الوثيقة",
  "documents.done": "تم",
  "documents.emailOptional": "البريد الإلكتروني (اختياري)",
  "documents.leaveEmptyToJust": "اتركه فارغاً لإنشاء رابط فقط",
  "documents.messageOptional": "الرسالة (اختياري)",
  "documents.cancel": "إلغاء",
  "documents.requestDocuments": "طلب الوثائق",
  "documents.sendASecureUpload": "إرسال رابط رفع آمن للعميل عبر البريد الإلكتروني.",
  "documents.clientEmail": "بريد العميل الإلكتروني *",
  "documents.clientName": "اسم العميل",
  "documents.requestedDocuments": "الوثائق المطلوبة *",
  "documents.renameFolder": "إعادة تسمية المجلد",
  "documents.selectADestinationFolder": "اختر مجلد الوجهة.",
  "documents.deleteDocument": "حذف الوثيقة؟",
  "settings.individual": "فردي",
  "settings.business": "تجاري",
  "settings.buyer": "مشتري",
  "settings.seller": "بائع",
  "settings.chooseYourPreferredTheme": "اختر المظهر المفضل لديك",
  "settings.light": "فاتح",
  "settings.dark": "داكن",
  "settings.system": "النظام",
  "settings.manufacturing": "التصنيع",
  "settings.insurance": "التأمين",
  "settings.realEstate": "العقارات",
  "settings.automotive": "السيارات",
  "settings.importexport": "الاستيراد/التصدير",
  "settings.other": "أخرى",
  "settings.brandingWhitelabel": "العلامة التجارية والتسمية البيضاء",
  "settings.customizeThePocketfilerExperience": "تخصيص تجربة PocketFiler لعملائك.",
  "settings.organizationLogo": "شعار المؤسسة",
  "settings.provideADirectLink": "قدم رابطاً مباشراً لشعار PNG أو SVG الشفاف.",
  "settings.primaryThemeColor": "لون المظهر الأساسي",
  "settings.selectAHexColor": "اختر كود لون سادس عشري لتمثيل اللكنات الأساسية لعلامتك التجارية.",
  "settings.accentHoverColor": "لون التمييز/التمرير",
  "settings.selectAHexColor1": "اختر لوناً سادس عشري لحالات التمرير والإبراز وعناصر التمييز.",
  "settings.customDomain": "نطاق مخصص",
  "settings.ensureYouConfigureA": "تأكد من تكوين سجل CNAME يشير إلى pocketfiler.com.",
  "settings.cancellationScheduled": "تم جدولة الإلغاء",
  "settings.yourLastPaymentFailed": "فشلت آخر عملية دفع. يرجى تحديث طريقة الدفع للحفاظ على الوصول.",
  "settings.chooseYourPlan": "اختر خطتك",
  "settings.monthly": "شهرياً",
  "settings.save20": "وفر 20%",
  "settings.current": "الحالية",
  "settings.popular": "الأكثر شيوعاً",
  "settings.contactSales": "اتصل بالمبيعات",
  "settings.googleCalendar": "Google Calendar",
  "settings.syncYourPocketfilerMeetings": "مزامنة اجتماعات PocketFiler مع Google Calendar",
  "settings.settingsPageErrorDebug": "خطأ في صفحة الإعدادات (تصحيح الأخطاء)",
  "invoices.createInvoice": "إنشاء فاتورة",
  "invoices.createANewInvoice": "إنشاء فاتورة جديدة للعميل",
  "invoices.selectClient": "اختيار العميل",
  "invoices.dueDate": "تاريخ الاستحقاق",
  "invoices.clientName": "اسم العميل",
  "invoices.clientEmail": "بريد العميل الإلكتروني",
  "invoices.lineItems": "بنود الفاتورة",
  "invoices.description": "الوصف",
  "invoices.qty": "الكمية",
  "invoices.price": "السعر",
  "invoices.tax": "الضريبة %",
  "invoices.total": "المجموع",
  "invoices.subtotal": "المجموع الفرعي:",
  "invoices.discount": "الخصم:",
  "invoices.tax1": "الضريبة:",
  "invoices.total1": "المجموع:",
  "invoices.notesOptional": "ملاحظات (اختياري)",
  "invoices.invoices": "الفواتير",
  "invoices.manageAndTrackYour": "إدارة وتتبع فواتيرك",
  "invoices.totalInvoiced": "إجمالي المفوتر",
  "invoices.paid": "مدفوع",
  "invoices.outstanding": "مستحق",
  "invoices.totalInvoices": "إجمالي الفواتير",
  "invoices.allInvoices": "جميع الفواتير",
  "invoices.myInvoices": "فواتيري",
  "invoices.receivedInvoices": "الفواتير المستلمة",
  "invoices.noInvoicesYet": "لا توجد فواتير بعد",
  "meetings.join": "انضمام",
  "meetings.end": "إنهاء",
  "meetings.meetingTitle": "عنوان الاجتماع",
  "meetings.date": "التاريخ",
  "meetings.time": "الوقت",
  "meetings.duration": "المدة",
  "meetings.repeat": "تكرار",
  "meetings.doesNotRepeat": "لا يتكرر",
  "meetings.weekly": "أسبوعياً",
  "meetings.every2Weeks": "كل أسبوعين",
  "meetings.monthly": "شهرياً",
  "meetings.invitePeopleOptional": "دعوة الأشخاص (اختياري)",
  "meetings.cancel": "إلغاء",
  "meetings.meetings": "الاجتماعات",
  "companyprofile.companyProfile": "ملف الشركة",
  "companyprofile.manageYourBusinessProfile": "إدارة ملف شركتك وفريقك",
  "companyprofile.publicProfile": "الملف العام",
  "companyprofile.basicInformation": "المعلومات الأساسية",
  "companyprofile.essentialDetailsAboutYour": "التفاصيل الأساسية حول شركتك",
  "companyprofile.companyName": "اسم الشركة",
  "companyprofile.tagline": "الشعار",
  "companyprofile.industry": "الصناعة",
  "companyprofile.companyType": "نوع الشركة",
  "companyprofile.description": "الوصف",
  "companyprofile.companyDetails": "تفاصيل الشركة",
  "companyprofile.additionalInformationAboutYour": "معلومات إضافية حول شركتك",
  "companyprofile.yearEstablished": "سنة التأسيس",
  "companyprofile.numberOfEmployees": "عدد الموظفين",
  "companyprofile.certifications": "الشهادات",
  "companyprofile.enterCertificationsSeparatedBy": "أدخل الشهادات مفصولة بفواصل",
  "companyprofile.languagesSpoken": "اللغات المحكية",
  "companyprofile.shippingRegions": "مناطق الشحن",
  "companyprofile.contactInformation": "معلومات الاتصال",
  "companyprofile.howPotentialPartnersCan": "كيف يمكن للشركاء المحتملين التواصل معك",
  "companyprofile.website": "الموقع الإلكتروني",
  "companyprofile.email": "البريد الإلكتروني",
  "companyprofile.phone": "الهاتف",
  "companyprofile.country": "الدولة",
  "companyprofile.city": "المدينة",
  "companyprofile.address": "العنوان",
  "companyprofile.teamMembers": "أعضاء الفريق",
  "companyprofile.manageUsersWithinYour": "إدارة المستخدمين داخل مؤسستك",
  "companyprofile.role": "الدور",
  "companyprofile.admin": "مدير",
  "companyprofile.member": "عضو",
  "companyprofile.viewer": "مشاهد",
  "companyprofile.titleOptional": "المسمى الوظيفي (اختياري)",
  "companyprofile.name": "الاسم",
  "companyprofile.title": "المسمى الوظيفي",
  "companyprofile.status": "الحالة",
  "companyprofile.actions": "الإجراءات",
  "companyprofile.owner": "المالك",
  "companyprofile.copyInviteLink": "نسخ رابط الدعوة",
  "companyprofile.removeMember": "إزالة العضو",
  "companyprofile.removeTeamMember": "إزالة عضو الفريق",
  "companyprofile.cancel": "إلغاء",
  "products.productsServices": "المنتجات والخدمات",
  "products.description": "الوصف",
  "products.pricing": "التسعير",
  "products.price": "السعر",
  "products.unit": "الوحدة",
  "products.details": "التفاصيل",
  "products.minOrderQty": "الحد الأدنى لكمية الطلب",
  "products.leadTime": "وقت التنفيذ",
  "products.category": "الفئة",
  "products.currency": "العملة",
  "products.leadTimeDays": "وقت التنفيذ (أيام)",
  "products.active": "نشط",
  "products.showInCatalog": "عرض في الكتالوج",
  "products.cancel": "إلغاء",
  "developersettings.reveal": "إظهار",
  "developersettings.copy": "نسخ",
  "developersettings.hide": "إخفاء",
  "developersettings.securityWarning": "تحذير أمني",
  "developersettings.neverShareThisKey": "لا تشارك هذا المفتاح علنياً أو في كود العميل",
  "developersettings.anyoneWithThisKey": "أي شخص لديه هذا المفتاح يمكنه قراءة وتعديل بياناتك",
  "developersettings.ifCompromisedRevokeImmediately": "في حالة التعرض للخطر، قم بإلغائه فوراً وإنشاء مفتاح جديد",
  "developersettings.iUnderstandAndAccept": "أفهم وأتحمل المسؤولية عن أمان هذا المفتاح",
  "developersettings.cancel": "إلغاء",
  "developersettings.revealKey": "إظهار المفتاح",
  "developersettings.accessDenied": "تم رفض الوصول",
  "developersettings.onlyBusinessAccountsHave": "الحسابات التجارية فقط لديها إمكانية الوصول إلى إعدادات المطورين",
  "developersettings.developerOverview": "نظرة عامة للمطورين",
  "developersettings.manageYourApiKeys": "إدارة مفاتيح API ونقاط Webhook للتكاملات مع الأطراف الثالثة",
  "developersettings.secretApiKeys": "مفاتيح API السرية",
  "developersettings.interactiveApiDocumentationRarr": "وثائق API التفاعلية &rarr;",
  "developersettings.name": "الاسم",
  "developersettings.key": "المفتاح",
  "developersettings.createdAt": "تاريخ الإنشاء",
  "developersettings.status": "الحالة",
  "developersettings.actions": "الإجراءات",
  "developersettings.webhookEndpoints": "نقاط Webhook",
  "developersettings.url": "الرابط",
  "developersettings.events": "الأحداث",
  "developersettings.description": "الوصف",
  "developersettings.done": "تم",
  "developersettings.addWebhookEndpoint": "إضافة نقطة Webhook",
  "developersettings.payloadUrl": "رابط الحمولة",
  "developersettings.eventsToSend": "الأحداث المراد إرسالها",
  "developersettings.sendMeEverything": "أرسل لي كل شيء (*)",
  "developersettings.dealStatusChangedDealstatuschanged": "تغيرت حالة الصفقة (deal.status_changed)",
  "developersettings.documentUploadedDocumentuploaded": "تم رفع المستند (document.uploaded)",
  "developersettings.descriptionOptional": "الوصف (اختياري)",
  "analytics.noDataAvailableFor": "لا توجد بيانات متاحة لهذه الفترة.",
  "analytics.noDealsFound": "لم يتم العثور على صفقات.",
  "analytics.noClientDataAvailable": "لا توجد بيانات عملاء متاحة لهذه الفترة.",
  "analytics.client": "العميل",
  "analytics.invoices": "الفواتير",
  "analytics.revenue": "الإيرادات",
  "analytics.totalPipeline": "إجمالي خط المبيعات",
  "analytics.noRecentActivityFor": "لا يوجد نشاط حديث لهذه الفترة.",
  "analytics.pipelineOverview": "نظرة عامة على خط المبيعات",
  "analytics.goToDeals": "انتقل إلى الصفقات",
  "analytics.analyticsDashboard": "لوحة التحليلات",
  "analytics.trackYourBusinessPerformance": "تتبع أداء أعمالك والرؤى التحليلية",
  "analytics.last7Days": "آخر 7 أيام",
  "analytics.last30Days": "آخر 30 يوماً",
  "analytics.last90Days": "آخر 90 يوماً",
  "analytics.lastYear": "السنة الماضية",
  "analytics.overview": "نظرة عامة",
  "analytics.myPerformance": "أدائي",
  "analytics.currentDealsByStatus": "الصفقات الحالية حسب الحالة",
  "analytics.revenueTrendsOverLast": "اتجاهات الإيرادات خلال آخر 6 أشهر",
  "analytics.accountsGeneratingTheMost": "الحسابات التي تحقق أكبر إيرادات",
  "analytics.currentCashFlowOverview": "نظرة عامة على التدفق النقدي الحالي",
  "analytics.latestBusinessActivitiesAnd": "أحدث الأنشطة التجارية والتحديثات",
  "compliance.complianceCenter": "مركز الامتثال",
  "compliance.hsCodesTariffsSanctions": "أكواد HS والتعريفات وفحص العقوبات وضوابط التصدير",
  "compliance.hsCodeClassification": "تصنيف كود HS",
  "compliance.productDescription": "وصف المنتج",
  "compliance.tariffCalculator": "حاسبة التعريفة",
  "compliance.estimateImportDutiesBased": "تقدير رسوم الاستيراد بناءً على كود HS ومسار التجارة.",
  "compliance.hsCode": "كود HS",
  "compliance.declaredValueUsd": "القيمة المصرحة (بالدولار الأمريكي)",
  "compliance.originCountry": "بلد المنشأ",
  "compliance.destinationCountry": "بلد الوجهة",
  "compliance.dutyRate": "معدل الرسوم:",
  "compliance.totalRate": "المعدل الإجمالي:",
  "compliance.estDuty": "الرسوم المقدرة:",
  "compliance.totalEstCost": "التكلفة الإجمالية المقدرة:",
  "compliance.tradeAgreements": "اتفاقيات التجارة:",
  "compliance.sanctionsScreening": "فحص العقوبات",
  "compliance.screenEntitiesAgainstOfac": "فحص الكيانات ضد قائمة OFAC SDN وعقوبات البلدان.",
  "compliance.entityName": "اسم الكيان",
  "compliance.type": "النوع",
  "compliance.company": "شركة",
  "compliance.individual": "فرد",
  "compliance.vessel": "سفينة",
  "compliance.countryOptional": "البلد (اختياري)",
  "compliance.usSanctionedCountries": "البلدان الخاضعة للعقوبات الأمريكية",
  "compliance.exportControlCheck": "فحص ضوابط التصدير",
  "compliance.aipoweredEaritarClassificationGuidance": "توجيهات تصنيف EAR/ITAR مدعومة بالذكاء الاصطناعي. ليست استشارة قانونية.",
  "compliance.producttechnologyDescription": "وصف المنتج/التقنية",
  "compliance.hsCodeOptional": "كود HS (اختياري)",
  "compliance.endUseOptional": "الاستخدام النهائي (اختياري)",
  "compliance.licenseRequired": "ترخيص مطلوب",
  "compliance.recommendations": "التوصيات:",
  "compliance.complianceHistory": "تاريخ الامتثال",
  "compliance.recentComplianceChecksFor": "فحوصات الامتثال الحديثة لمؤسستك.",
  "compliance.noComplianceChecksYet": "لا توجد فحوصات امتثال بعد. قم بتشغيل الفحص الأول أعلاه.",
  "intelligence.marketIntelligence": "ذكاء السوق",
  "intelligence.anonymizedTradeDataAnd": "بيانات التجارة المجهولة والمعايير المرجعية من منصة PocketFiler",
  "intelligence.demandByCategory": "الطلب حسب الفئة",
  "intelligence.whatBuyersAreSourcing": "ما يقوم المشترون بتوريده على المنصة (آخر 90 يوماً)",
  "intelligence.noDemandDataYet": "لا توجد بيانات طلب بعد. تتم تعبئة البيانات عند إنشاء طلبات التسعير على المنصة.",
  "intelligence.byIndustry": "حسب الصناعة",
  "intelligence.noSupplierDataYet": "لا توجد بيانات موردين بعد.",
  "intelligence.byCountry": "حسب البلد",
  "intelligence.byType": "حسب النوع",
  "intelligence.byVerification": "حسب التحقق",
  "intelligence.noDataYet": "لا توجد بيانات بعد.",
  "intelligence.yourPerformanceVsPlatform": "أداؤك مقابل المنصة",
  "intelligence.seeHowYouStack": "اطلع على موقعك مقارنة بمتوسطات المنصة",
  "intelligence.completeSomeDealsTo": "أكمل بعض الصفقات لرؤية المعايير المرجعية.",
  "virtualoffices.virtualOffices": "المكاتب الافتراضية",
  "virtualoffices.manageYourBrandedWorkspaces": "إدارة مساحات العمل ذات العلامة التجارية الخاصة بك",
  "virtualoffices.officeName": "اسم المكتب",
  "virtualoffices.industry": "الصناعة",
  "virtualoffices.languagesServed": "اللغات المخدومة",
  "virtualoffices.descriptionOptional": "الوصف (اختياري)",
  "virtualoffices.documentChecklist": "قائمة فحص المستندات",
  "virtualoffices.languages": "اللغات",
  "tasks.tasks": "المهام",
  "tasks.noTasksYet": "لا توجد مهام بعد",
  "tasks.dragTasksHere": "اسحب المهام هنا",
  "tasks.createNewTask": "إنشاء مهمة جديدة",
  "tasks.descriptionOptional": "الوصف (اختياري)",
  "tasks.relatedDealOptional": "الصفقة ذات الصلة (اختياري)",
  "tasks.noDealAttached": "لا توجد صفقة مرفقة",
  "tasks.assignees": "المكلفون",
  "tasks.noTeamMembersAvailable": "لا يوجد أعضاء فريق متاحون. يمكن تكليف الأعضاء النشطين فقط.",
  "tasks.cancel": "إلغاء",
  "tasks.description": "الوصف",
  "tasks.status": "الحالة",
  "tasks.relatedDeal": "الصفقة ذات الصلة",
  "tasks.noAssignees": "لا يوجد مكلفون",
  "tasks.areYouAbsolutelySure": "هل أنت متأكد تماماً؟",
  "events.events": "الفعاليات",
  "events.tradeShowsWebinarsAnd": "المعارض التجارية والندوات الإلكترونية وفعاليات التواصل",
  "events.createEvent": "إنشاء فعالية",
  "events.title": "العنوان",
  "events.description": "الوصف",
  "events.category": "الفئة",
  "events.type": "النوع",
  "events.locationUrl": "الموقع / الرابط",
  "events.startDateTime": "تاريخ ووقت البداية",
  "events.endDateTime": "تاريخ ووقت النهاية",
  "events.maxAttendeesOptional": "الحد الأقصى للحضور (اختياري)",
  "events.cancel": "إلغاء",
  "events.allCategories": "جميع الفئات",
  "events.noEventsFoundCreate": "لم يتم العثور على فعاليات. قم بإنشاء الأولى!",
  "events.featured": "المميزة",
  "events.previous": "السابق",
  "events.next": "التالي",
  "status.pendingDocuments": "في انتظار الوثائق",
  "status.pendingSignature": "في انتظار التوقيع",
  "status.pendingPayment": "في انتظار الدفع",
  "status.completed": "مكتمل",
  "status.updated": "محدث",
  "status.onHold": "معلق",
  "activity.deal": "الصفقة",
  "activity.action.analyzed": "تم التحليل",
  "activity.action.uploaded": "تم الرفع",
  "activity.action.downloaded": "تم التحميل",
  "activity.action.previewed": "تمت المعاينة",
  "activity.action.shared": "تم المشاركة",
  "activity.action.status_changed": "تم تغيير الحالة",
  "activity.action.updated": "تم التحديث",
  "activity.action.created": "تم الإنشاء",
  "activity.action.archived": "تم الأرشفة",
  "activity.action.restored": "تم الاستعادة",
  "analytics.totalRevenue": "إجمالي الإيرادات",
  "analytics.totalDeals": "إجمالي الصفقات",
  "analytics.conversionRate": "معدل التحويل",
  "analytics.avgDealValue": "متوسط قيمة الصفقة",
  "analytics.dealPipeline": "مسار الصفقات",
  "analytics.monthlyRevenue": "الإيرادات الشهرية",
  "analytics.topClientsByRevenue": "أفضل العملاء حسب الإيرادات",
  "analytics.invoiceHealth": "حالة الفواتير",
  "analytics.paid": "مدفوع",
  "analytics.pendingPayment": "في انتظار الدفع",
  "companyprofile.saveProfile": "حفظ الملف الشخصي",
  "companyprofile.makeVisible": "اجعل شركتك مرئية في الدليل",
  "companyprofile.tab.basicInfo": "المعلومات الأساسية",
  "companyprofile.tab.details": "التفاصيل",
  "companyprofile.tab.contact": "التواصل",
  "companyprofile.tab.team": "الفريق",
  "companyprofile.tab.verification": "التحقق",
  "companyprofile.selectType": "اختر النوع",
  "companyprofile.describePlaceholder": "صف شركتك ومنتجاتها وخدماتها...",
  "companyprofile.industry.other": "أخرى",
  "companyprofile.preview": "معاينة",
  "companyprofile.ph.companyName": "شركتكم المحدودة",
  "companyprofile.ph.tagline": "منتجات عالية الجودة، وصول عالمي",
  "companyprofile.ph.selectIndustry": "اختر الصناعة",
  "companyprofile.ph.selectSize": "اختر الحجم",
  "companyprofile.ph.certifications": "ISO 9001، CE، FDA (مفصولة بفواصل)",
  "companyprofile.ph.languages": "الإنجليزية، الإسبانية، الصينية",
  "companyprofile.ph.exportRegions": "أمريكا الشمالية، أوروبا، آسيا",
  "companyprofile.ph.selectCountry": "اختر البلد",
  "companyprofile.ph.city": "لوس أنجلوس",
  "companyprofile.ph.teamName": "اسم عضو الفريق",
  "companyprofile.ph.addTitle": "إضافة عنوان...",
  "companyprofile.inviteTeamMember": "دعوة عضو فريق",
  "companyprofile.invitationSent": "تم إرسال الدعوة بنجاح",
  "virtualoffices.newOffice": "مكتب جديد",
  "virtualoffices.createOffice": "إنشاء مكتب افتراضي",
  "virtualoffices.reviewChecklist": "مراجعة قائمة الوثائق",
  "virtualoffices.setupDesc": "إعداد مساحة عمل جديدة مخصصة لعلامتك التجارية لعملك",
  "virtualoffices.customizeDesc": "تخصيص الوثائق التي تحتاجها من العملاء",
  "virtualoffices.ph.officeName": "مثال: شركة غارسيا للتأمين - بوالص السيارات",
  "virtualoffices.ph.description": "اوصف تركيز مكتبك...",
  "virtualoffices.ph.addDocument": "إضافة وثيقة مخصصة...",
  "virtualoffices.generating": "جارٍ الإنتاج...",
  "virtualoffices.aiChecklist": "قائمة مراجعة مُنتجة بالذكاء الاصطناعي لـ",
  "virtualoffices.clients": "العملاء",
  "virtualoffices.pending": "قيد الانتظار",
  "virtualoffices.invite": "دعوة",
  "virtualoffices.ind.manufacturing": "التصنيع",
  "virtualoffices.ind.insurance": "التأمين",
  "virtualoffices.ind.real_estate": "العقارات",
  "virtualoffices.ind.automotive": "السيارات",
  "virtualoffices.ind.import_export": "الاستيراد والتصدير",
  "virtualoffices.ind.other": "أخرى",
  "messages.conversations": "المحادثات",
  "messages.searchPlaceholder": "البحث في الرسائل...",
  "messages.noConversations": "لا توجد محادثات",
  "messages.send": "إرسال",
  "messages.selectConversation": "اختر محادثة",
  "messages.selectConversationDesc": "اختر محادثة من الشريط الجانبي لبدء المحادثة",
  "messages.support": "الدعم",
  "messages.client": "العميل",
  "messages.deal": "الصفقة",
  "meetings.subtitle": "جدولة وإدارة الاجتماعات المرئية",
  "meetings.upcoming": "القادمة",
  "meetings.past": "السابقة",
  "meetings.schedule": "جدولة",
  "meetings.startInstant": "بدء فوري",
  "meetings.startNow": "ابدأ الآن",
  "meetings.noPast": "لا توجد اجتماعات سابقة",
  "meetings.noUpcoming": "لا توجد اجتماعات قادمة",
  "meetings.createMeeting": "إنشاء اجتماع",
  "meetings.startInstantMeeting": "بدء اجتماع فوري",
  "meetings.scheduleMeeting": "جدولة اجتماع",
  "meetings.scheduleDesc": "جدولة اجتماع مرئي وإرسال الدعوات.",
  "meetings.invitePeople": "دعوة الأشخاص (اختياري)",
  "meetings.15min": "15 دقيقة",
  "meetings.30min": "30 دقيقة",
  "meetings.45min": "45 دقيقة",
  "meetings.allowRecording": "السماح بالتسجيل",
  "meetings.recordingDesc": "يمكّن المضيف من تسجيل هذا الاجتماع",
  "meetings.waitingRoom": "غرفة الانتظار",
  "meetings.waitingRoomDesc": "يجب على المشاركين الحصول على إذن من المضيف قبل الانضمام",
  "meetings.emailPlaceholder": "email@example.com",
  "meetings.cancelConfirm": "إلغاء هذا الاجتماع؟",
  "meetings.cancelMeeting": "إلغاء الاجتماع",
  "documents.title": "المستندات",
  "documents.viewAll": "عرض الكل",
  "documents.archived": "مؤرشف",
  "documents.requestDocs": "طلب المستندات",
  "documents.upload": "رفع",
  "documents.allDocuments": "جميع المستندات",
  "documents.searchPlaceholder": "البحث في المستندات...",
  "documents.addTag": "إضافة علامة...",
  "documents.uploadDesc": "اسحب وأفلت الملفات أو انقر للتصفح. ملفات PDF والصور ومستندات Word مدعومة.",
  "documents.emailPlaceholder": "client@example.com",
  "documents.shareMsgPlaceholder": "إليك المستند الذي طلبته...",
  "documents.requestDesc": "إرسال رابط رفع آمن إلى العميل عبر البريد الإلكتروني.",
  "documents.namePlaceholder": "أحمد محمد",
  "documents.requestMsgPlaceholder": "يرجى رفع المستندات التالية...",
  "documents.folderName": "اسم المجلد",
  "documents.selectDestination": "اختر مجلد الوجهة.",
  "documents.statusUploaded": "تم الرفع",
  "documents.statusAnalyzed": "تم التحليل",
  "documents.statusArchived": "مؤرشف",
  "documents.allTypes": "جميع الأنواع",
  "documents.inArchive": "في الأرشيف",
  "templates.allTemplates": "جميع القوالب",
  "templates.editTemplate": "تحرير القالب",
  "templates.createCustomTemplate": "إنشاء قالب مخصص",
  "templates.editDesc": "تحديث قالب المستند الخاص بك",
  "templates.createDesc": "إنشاء قالب مستند قابل لإعادة الاستخدام",
  "templates.ph.templateName": "مثال: اتفاقية عدم إفشاء مخصصة",
  "templates.ph.description": "وصف مختصر للقالب",
  "templates.ph.content": "أدخل محتوى القالب هنا...",
  "templates.saving": "جارٍ الحفظ...",
  "templates.creating": "جارٍ الإنشاء...",
  "templates.saveChanges": "حفظ التغييرات",
  "templates.createTemplate": "إنشاء قالب",
  "templates.searchPlaceholder": "البحث في القوالب...",
  "templates.popularTemplates": "القوالب الشائعة",
  "templates.defaultTemplates": "القوالب الافتراضية",
  "templates.deleteTemplate": "حذف القالب",
  "templates.preview": "معاينة",
  "templates.description": "الوصف",
  "products.searchPlaceholder": "البحث في المنتجات...",
  "products.ph.service": "خدمات استشارية",
  "products.ph.product": "ويدجت برو 3000",
  "products.selectCategory": "اختر الفئة",
  "products.ph.describe": "صف منتجك أو خدمتك...",
  "products.noMatches": "لم يتم العثور على نتائج مطابقة",
  "products.noProducts": "لا توجد منتجات أو خدمات بعد",
  "products.serviceDetails": "تفاصيل الخدمة",
  "products.productDetails": "تفاصيل المنتج",
  "products.inactive": "غير نشط",
  "products.deleteConfirm": "حذف هذا العنصر؟",
  "products.saveChanges": "حفظ التغييرات",
  "products.addItem": "إضافة عنصر",
  "products.priceOnRequest": "السعر عند الطلب",
  "products.perUnit": "لكل وحدة",
  "tasks.searchPlaceholder": "البحث في المهام...",
  "tasks.ph.title": "مثال: مراجعة الوثائق القانونية",
  "tasks.ph.description": "أضف المزيد من السياق لهذه المهمة...",
  "tasks.selectDeal": "اختر صفقة لإرفاقها",
  "tasks.noTasks": "لا توجد مهام في هذا العمود",
  "tasks.deleteTask": "حذف المهمة",
  "settings.tabs.branding": "العلامة التجارية",
  "settings.tabs.payments": "المدفوعات",
  "settings.tabs.plan": "الخطة",
  "settings.tabs.integrations": "التكاملات",
  "settings.appearance": "المظهر",
  "settings.saveBranding": "حفظ العلامة التجارية",
  "settings.yourPlan": "خطتك",
  "settings.ph.logoUrl": "https://example.com/logo.png",
  "settings.ph.customDomain": "deals.yourcompany.com",
  "settings.calendarFeedGenerated": "تم إنشاء رابط التقويم بنجاح!",
  "settings.plan.free": "مجاني",
  "settings.plan.pro": "احترافي",
  "settings.plan.smallBusiness": "الأعمال الصغيرة",
  "settings.plan.businessPro": "الأعمال الاحترافية",
  "settings.plan.scale": "التوسع",
  "settings.plan.enterprise": "المؤسسات",
  "dealroom.meetings": "الاجتماعات",
  "dealroom.startMeeting": "بدء الاجتماع",
  "dealroom.noMeetings": "لا توجد اجتماعات مرتبطة بهذه الصفقة بعد",
  "dealroom.noMeetingsDesc": "ابدأ اجتماعاً أو قم بجدولة واحد للبدء",
  "dealroom.failedCreateMeeting": "فشل في إنشاء الاجتماع",
  "dealroom.finalizedContract": "العقد المُكتمل — جاهز للتوقيع",
  "dealroom.previewNotSupported": "المعاينة غير مدعومة",
  "dealroom.aiMayTakeMoment": "قد يستغرق هذا الأمر بعض الوقت.",
  "dealroom.aiAnalysisGenerated": "تم إنشاء تحليل الذكاء الاصطناعي للوثائق التالية:",
  "dealroom.docsUnanalyzed": "الوثائق التالية تبقى غير محللة:",
  "dealroom.analyzingDocs": "جاري تحليل الوثائق...",
  "dealroom.finalizeWarning": "لا يمكن التراجع عن هذا الإجراء. ستتغير حالة الصفقة إلى في انتظار التوقيع وسيتمكن جميع الأطراف من توقيع العقد.",
  "dealroom.cannotRevert": "لا يمكن التراجع من حالة في انتظار التوقيع",
  "compliance.ph.productDesc": "مثال: براغي من الفولاذ المقاوم للصدأ، M10 x 50mm...",
  "compliance.ph.exportDesc": "وصف المنتج أو التقنية المراد تصديرها...",
  "compliance.select": "اختر...",
  "compliance.selectCountry": "اختر البلد...",
  "events.tradeShow": "معرض تجاري",
  "events.webinar": "ندوة إلكترونية",
  "events.networking": "التواصل المهني",
  "events.conference": "مؤتمر",
  "events.workshop": "ورشة عمل",
  "events.ph.title": "عنوان الفعالية",
  "events.ph.location": "عنوان المكان أو رابط الاجتماع",
  "events.ph.maxAttendees": "اتركه فارغاً للعدد غير المحدود",
  "events.searchPlaceholder": "البحث في الفعاليات...",
  "events.cancelRsvp": "إلغاء RSVP",
  "events.rsvp": "RSVP",
  "rfq.expired": "منتهي الصلاحية",
  "rfq.createRfq": "إنشاء طلب عرض سعر",
  "rfq.visibility": "الظهور",
  "rfq.public": "عام - يمكن لجميع الموردين الاطلاع",
  "rfq.private": "خاص - بالدعوة فقط",
  "rfq.quantity": "الكمية",
  "rfq.unit": "الوحدة",
  "rfq.pieces": "قطع",
  "rfq.kilograms": "كيلوغرام",
  "rfq.meters": "متر",
  "rfq.squareMeters": "متر مربع",
  "rfq.units": "وحدات",
  "rfq.sets": "مجموعات",
  "rfq.boxes": "صناديق",
  "rfq.deliveryLocation": "موقع التسليم",
  "rfq.deliveryDeadline": "موعد التسليم النهائي",
  "rfq.specialRequirements": "المتطلبات الخاصة",
  "rfq.title": "طلبات عروض الأسعار",
  "rfq.subtitle": "تصفح طلبات التوريد أو انشر طلبك الخاص",
  "rfq.rfqsPosted": "RFQs منشورة",
  "rfq.openRfqs": "RFQs مفتوحة",
  "rfq.quotesSent": "عروض أسعار مرسلة",
  "rfq.winRate": "معدل الفوز",
  "rfq.allCategories": "جميع الفئات",
  "rfq.noRfqsFound": "لم يتم العثور على RFQs",
  "rfq.noRfqsYet": "لا توجد RFQs بعد",
  "meetings.biweekly": "كل أسبوعين",
  "meetings.cancelSeries": "إلغاء السلسلة بأكملها",
  "meetings.cancelThisMeeting": "إلغاء هذا الاجتماع",
  "meetings.nextInSeries": "التالي في السلسلة",
  "nav.contractTemplates": "العقود",
  "contracts.title": "نماذج العقود",
  "contracts.subtitle": "إنشاء مستندات قانونية بالذكاء الاصطناعي. اختر قالبًا للبدء.",
  "documents.create": "إنشاء",
  "createDoc.untitledDocument": "مستند بدون عنوان",
  "createDoc.save": "حفظ",
  "createDoc.export": "تصدير",
  "createDoc.aiAssist": "مساعد الذكاء",
  "createDoc.generate": "إنشاء",
  "createDoc.generating": "جاري الإنشاء...",
  "createDoc.cancel": "إلغاء",
  "createDoc.translate": "ترجمة",
  "createDoc.translateTitle": "ترجمة المستند",
  "createDoc.translateTo": "ترجمة إلى",
  "createDoc.translateNow": "ترجمة",
  "createDoc.translating": "جاري الترجمة...",
  "createDoc.translated": "تمت ترجمة المستند بنجاح",
  "createDoc.translateFailed": "فشلت الترجمة",
  "verification.status": "حالة التحقق",
  "verification.inProgress": "التحقق قيد التنفيذ",
  "verification.getVerified": "التحقق",
  "verification.cancelRequest": "إلغاء الطلب",
  "verification.submit": "إرسال للتحقق",
  "verification.submitting": "جاري الإرسال...",
  "verification.uploadDocs": "رفع المستندات",
  "verification.level": "مستوى التحقق",
  "verification.selectDocType": "اختر نوع المستند...",
  "contracts.generate": "إنشاء",
  "contracts.backToTemplates": "العودة إلى القوالب",
  "contracts.required": "مطلوب",
  "contracts.modify": "تعديل",
  "contracts.finalize": "إنهاء",
  "contracts.applyChanges": "تطبيق التغييرات",
  "contracts.confirmDelete": "حذف هذه المسودة؟",
  "contracts.generating": "جاري إنشاء المستند...",
  "contracts.nda": "اتفاقية سرية متبادلة",
  "contracts.sow": "بيان العمل",
  "contracts.msa": "اتفاقية خدمات رئيسية",
  "contracts.contractor": "عقد مقاول مستقل",
  "contracts.loi": "خطاب نوايا",
  "templates.deleting": "جاري الحذف...",
  "templates.noDescription": "لا يوجد وصف.",
  "templates.use": "استخدام",
  "templates.lib.ndaMutual": "اتفاقية سرية متبادلة",
  "templates.lib.purchaseAgreement": "اتفاقية شراء",
  "templates.lib.serviceAgreement": "اتفاقية خدمات",
  "templates.lib.priceQuote": "عرض سعر",
  "templates.lib.invoice": "فاتورة",
  "templates.lib.loi": "خطاب نوايا",
  "settings.security": "الأمان",
  "security.twoFactor": "المصادقة الثنائية",
  "security.enabled": "مفعّل",
  "security.disabled": "معطّل",
  "security.enable2FA": "تفعيل المصادقة الثنائية",
  "security.disable": "تعطيل",
  "security.activeSessions": "الجلسات النشطة",
  "security.logoutAll": "تسجيل الخروج من الكل",
  "security.lastUsed": "آخر استخدام",
  "security.currentSession": "الحالية",
  "security.loginHistory": "سجل الدخول",
  "security.successfulLogin": "دخول ناجح",
  "security.failedLogin": "محاولة فاشلة",
  "security.verify": "تحقق",
  "security.cancel": "إلغاء",
  "security.password": "كلمة المرور",
  "security.done": "تم",
  "feedback.button": "ملاحظات",
  "feedback.title": "إرسال ملاحظات",
  "feedback.typeBug": "خطأ",
  "feedback.typeFeature": "ميزة",
  "feedback.typeGeneral": "عام",
  "feedback.submit": "إرسال",
  "feedback.thanks": "شكراً! سنراجع ذلك.",
};

export default ar;
